import Axios from 'axios'
import Qs from 'qs'
// const baseURL = process.env.VUE_APP_BASE_API
import {
  baseUrl
} from '@/config/env'

import Auth from '@/utils/auth.js'
const $axios = Axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  },
  transformRequest: [function (req) {
    // return Qs.stringify(req)
    return JSON.stringify(req)
  }]
})

/* request interceptor */
$axios.interceptors.request.use(config => {
  // console.log(config)
  return config
}, error => {
  console.warn(error)
  return Promise.reject(error)
})

/* response interceptor */
$axios.interceptors.response.use(res => {

  // if (response.data.resCode == '405') {
  //   Auth.removeToken()
  //   Auth.removeVuex()
  //   router.replace({
  //     path: '/login'
  //   })
  // }
  return res
}, error => {
  console.warn(error)
  return Promise.reject(error)
})

export default $axios